//  scp -r build/* ha_replication@192.168.10.17:/var/www/html/ETHWebsite/
// kill -9 $(lsof -ti:3000)
import { Link } from "react-router-dom";
import { NavLink } from "react-router-dom";

import { useState, useEffect } from "react";
import { motion } from "framer-motion";
export function Navbar() {
  // Initialize darkMode state
  const [darkMode, setDarkMode] = useState(false);

  return (
    <nav className="bg-white shadow-md p-4 flex justify-between items-center">
      <div className="text-xl font-bold text-company-main-color">
        <img
          src="/images/logo.png"
          alt="Company Logo"
          height="50px"
          width="90px"
        />
      </div>
      <ul className="hidden md:flex gap-6 text-gray-600">
        <li className="text-menu-item-color">
          <NavLink
            to="/"
            className={({ isActive }) =>
              isActive
                ? "text-menu-item-color border-b-2 border-blue-600 pb-1"
                : "text-menu-item-color hover:border-b-2 hover:border-blue-400 pb-1 transition"
            }
          >
            Home
          </NavLink>
        </li>
        <li className="text-menu-item-color">
          <NavLink
            to="/dukaree"
            className={({ isActive }) =>
              isActive
                ? "text-menu-item-color border-b-2 border-blue-600 pb-1"
                : "text-menu-item-color hover:border-b-2 hover:border-blue-400 pb-1 transition"
            }
          >
            Sales & Distribution
          </NavLink>
        </li>
        <li className="text-menu-item-color">
          <NavLink
            to="/erp"
            className={({ isActive }) =>
              isActive
                ? "text-menu-item-color border-b-2 border-blue-600 pb-1"
                : "text-menu-item-color hover:border-b-2 hover:border-blue-400 pb-1 transition"
            }
          >
            ERP Solutions
          </NavLink>
        </li>
        <li className="text-menu-item-color">
          <NavLink
            to="/production"
            className={({ isActive }) =>
              isActive
                ? "text-menu-item-color border-b-2 border-blue-600 pb-1"
                : "text-menu-item-color hover:border-b-2 hover:border-blue-400 pb-1 transition"
            }
          >
            Smart Production
          </NavLink>
        </li>
        <li className="text-menu-item-color">
          <NavLink
            to="/warehouse"
            className={({ isActive }) =>
              isActive
                ? "text-menu-item-color border-b-2 border-blue-600 pb-1"
                : "text-menu-item-color hover:border-b-2 hover:border-blue-400 pb-1 transition"
            }
          >
            Warehouse & Delivery
          </NavLink>
        </li>
        <li className="text-menu-item-color">
          <NavLink
            to="/aipo"
            className={({ isActive }) =>
              isActive
                ? "text-menu-item-color border-b-2 border-blue-600 pb-1"
                : "text-menu-item-color hover:border-b-2 hover:border-blue-400 pb-1 transition"
            }
          >
            AI PO Processing
          </NavLink>
        </li>
        <li className="text-menu-item-color">
          <NavLink
            to="/integration"
            className={({ isActive }) =>
              isActive
                ? "text-menu-item-color border-b-2 border-blue-600 pb-1"
                : "text-menu-item-color hover:border-b-2 hover:border-blue-400 pb-1 transition"
            }
          >
            System Integrations
          </NavLink>
        </li>
      </ul>
      <div className="flex gap-4">
        {/* Dark mode toggle button */}
        {/* <button
          className="fixed top-4 right-4 z-50 p-2 bg-green-600 text-white rounded-full shadow-lg"
          onClick={() => setDarkMode(!darkMode)}
          aria-label="Toggle Dark Mode"
        >
          {darkMode ? "☀️" : "🌙"}
        </button> */}
        {/* <button className="company-main-color text-white px-4 py-2 rounded-full hover:bg-white hover:text-company-main-color">
          Request Demo
        </button> */}
      </div>
    </nav>
  );
}
